import { Typography } from "@mui/material";
import React from "react";
import { colors } from "../../../common/colors";

interface Props {
  title: string | React.ReactElement
  body: React.ReactElement
  style?: React.CSSProperties
}

export default function Section({ title, body, style }: Props) {
  return (
    <>
      <Typography style={{
        borderBottomColor: colors.farm_green500,
        borderBottomWidth: 2,
        borderBottomStyle: "solid" as const,
        fontSize: 14,
        fontFamily: "mplus-1c-bold",
        marginBottom: 6,
        marginTop: 20,
        ...style
      }}>{ title }</Typography>
      { body }
    </>
  )
}
